<template>
    <div class='layer-pop alert-pop'>
        <div class='view-content'>
            <div class='view-area'
                :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
            </div>
            <div class='body-area'>
                <p class='body'>{{ title }}</p>
                <p class='body-small'>{{ body }}</p>
            </div>
            <button @click='onClickBtnCancel' class='close-text'>확인</button>
            <p v-if='isTimeLimit' class='time-limit'>
                {{limitTime}}초 후 초기 화면으로 돌아갑니다.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'imageAlert2',
    props: {
        imgUrl: {
            type: String,
        },
        title: {
            type: String,
        },
        body: {
            type: String,
        },
        isTimeLimit: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        // 자동 팝업 닫힘
        if(this.isTimeLimit) {
            let timer = setInterval(() => {
                this.limitTime--;
                if(this.limitTime == 0) {
                    clearInterval(timer);
                    this.$emit('close-popup');
                }
            }, 1000);
        }
    },
    data() {
        return {
            limitTime: 5,
        };
    },
    methods: {
        onClickBtnCancel() {
            this.$emit('close-popup');
        },
    },
};
</script>

<style scoped>
    .view-content {
        width: 500px !important;
    }

    .time-limit {
        margin-top: 16px;
        font-family: Noto Sans CJK KR;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.6000000238418579px;
        text-align: center;
        color: #777777;
    }

</style>
